import axios from 'axios'
//import router from '../../../router'

export const checkIfTenantExists = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/signup/index.php', payload)
    .then(res => {
        
        if(res.data.status) {
            commit('setTenantSignupId', res.data.tenant_id)                  
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const checkTenantConfirmationCode = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/signup/checkTenantConfirmationCode.php', payload)
    .then(res => {
        
        if(res.data.status) {
            localStorage.setItem('accessToken', res.data.access_token)
            dispatch('checkAccessToken', { navigate: true })
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true})                
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/signup/actions.js